export const OFFER_NOT_ACCEPTED = 'Offer not accepted'
